import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import EdapModuleView from '../EdapModuleView';
import { TALL_CAROUSEL_ASPECT_RATIO } from '../Carousel/constants';
import PropertyTypeCard from './PropertyTypeCard';
import { buildPropertyTypeSerpUrl } from './utils';
import { Experiment } from '../Experiment';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';
import {
  PROPERTY_TYPES_LINK_CLICK,
  PROPERTY_TYPES_CLICK_PREV,
  PROPERTY_TYPES_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

class PropertyTypes extends Component {
  static propTypes = {
    propertyTypes: PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(PropTypes.shape({
        typeId: PropTypes.string.isRequired,
        serpFilter: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })).isRequired
    }).isRequired,
    siteName: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
    minCards: PropTypes.number,
    fetchPropertyTypeImages: PropTypes.func,
    propertyTypeImages: PropTypes.objectOf(PropTypes.string),
    cookie: PropTypes.string
  };

  static defaultProps = {
    minCards: 5,
    propertyTypeImages: {}
  }

  componentDidMount() {
    if (this.hasPropertyTypes()) {
      this.props.fetchPropertyTypeImages();
    }
  }

  handlePreviousClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_NEXT);
  }

  hasPropertyTypes = () => {
    const { propertyTypes, minCards } = this.props;
    return propertyTypes.items && propertyTypes.items.length >= minCards;
  }

  render() {
    const {
      propertyTypes,
      cookie,
      destination,
      propertyTypeImages
    } = this.props;

    if (!this.hasPropertyTypes()) {
      return null;
    }

    return (
      <EdapModuleView
        eventOptions={MODULE_VIEW_EVENT_OPTIONS}
        tagName="section"
        className= "Content__section"
      >
        <Experiment name="HA_PTA_LANDING_OptimizedPropertyTypeSort" report>
          <Experiment name="HA_PTA_LANDING_PropertyTypesSubheading" minTopValue={'32'} report>
            <Carousel
              title={propertyTypes.title}
              subheading={propertyTypes.subheading}
              cardAspectRatio={TALL_CAROUSEL_ASPECT_RATIO}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
              ssrEnabled // For SEO purposes
            >
              {propertyTypes.items.map(
                ({
                  typeId,
                  serpFilter,
                  title,
                  subtitle
                }, index) => (
                  <PropertyTypeCard
                    typeId={typeId}
                    title={title}
                    key={index}
                    imageUri={propertyTypeImages[typeId] || ''}
                    clickUrl={buildPropertyTypeSerpUrl({ destination, serpFilter, cookie })}
                    subtitle={subtitle}
                    onClick={handleEdapClick(PROPERTY_TYPES_LINK_CLICK, { typeId, index: index + 1 })}
                  />
                )
              )}
            </Carousel>
          </Experiment>
        </Experiment>
      </EdapModuleView>
    );
  }
}

export default PropertyTypes;
